import date from '~/components/Form/Field/Date.vue'

function formatDate(date) {
  if (!date) return null
  if (date.length > 10) {
    const dateArray = date.split(' ')
    return `${dateArray[0].split('.').reverse().join('-')}T${dateArray[1]}`
  } else {
    return `${date.split('.').reverse().join('-')}T00:00:00`
  }
}

function parseCustomDate(datetimeStr) {
  if (!datetimeStr) return null
  const [datePart] = datetimeStr.split(' ');
  const [day, month, year] = datePart.split('.');
  return new Date(`${year}-${month}-${day}`);
}

function checkPeriod(dateFrom, dateTo) {
  if (dateFrom && dateTo) {
    return Date.now() > Date.parse(dateFrom)
        && Date.now() < Date.parse(dateTo)
  } else {
    if (dateFrom) {
      return Date.now() > Date.parse(dateFrom)
    }
    if (dateTo) {
      return Date.now() < Date.parse(dateTo)
    }
    return true
  }
}

export const state = () => ({
  testsError: {
    registration: '',
    tests: '',
    results: '',
    popupStatement: '',
    alertConfirm: '',
    appealNew: ''
  },
  disciplines: [],
  allTests: [],
  selectedTests: [],
  testsResults: [],
  selectedDatetimeArray: [],
  appealDoc: null,
  testsPageLoading: true,
});

export const actions = {
  async setDisciplines({commit, state}) {
    this.$api("getEntrantTestDisciplines", {}, "POST")
        .then(result => {
          commit("SET_DISCIPLINES", result.data.DISCIPLINES)
        })
        .catch((error) => {
          commit("STOP_LOADER")
        })
  },
  async setAllTests({commit, state}) {
    this.$api("getEntrantTestDisciplines", {}, "POST")
        .then(result => {
          commit("SET_DISCIPLINES", result.data.DISCIPLINES)
          return result.data.DISCIPLINES_IDS
        })
        .then(disciplines => {
          this.$api("getMyExams", {DISCIPLINES: disciplines}, "POST")
              .then(result => {
                const exams = result.data.exams
                let tests = []
                if (exams && exams.length) {
                  exams.forEach(exam => {
                    const disciplineId = exam.ID.toString()
                    const disciplineName = exam.NAME
                    const discplineType = exam.TYPE
                    const eduLevel = {title: exam.EDU_LEVEL.NAME, id: exam.EDU_LEVEL.ID};

                    const examObject = {
                      title: disciplineName,
                      code: disciplineId,
                      type: discplineType,
                      form: '',
                      format: '',
                      formatSelectItems: [],
                      formSelectItems: [],
                      branch: '',
                      datetime: '',
                      branchSelectItems: [],
                      filteredBranchSelectItems: [],
                      datetimeSelectItems: [],
                      filteredDatetimeSelectItems: [],
                      hidden: false,
                      sameDateWarningFile: null,
                      eduLevel: eduLevel,
                      save: false
                    };

                    if (exam.EXAM_LIST && exam.EXAM_LIST.length) {
                      exam.EXAM_LIST.forEach(listItem => {

                        const params = listItem.PROPERTIES
                        let haveRemoteSlots = false

                        if (listItem.ACTIVE_FROM) {
                          const datetime = formatDate(listItem.ACTIVE_FROM)
                          const dateTimeLabel = listItem.ACTIVE_FROM.length === 10 ? `${listItem.ACTIVE_FROM} 00:00` : listItem.ACTIVE_FROM.slice(0, 16)

                          const isRemote = params.REMOTE === "Y" ? true : false
                          const dateObject = {
                            id: listItem.ID.toString(),
                            label: dateTimeLabel,
                            datetime: datetime,
                            remote: isRemote,
                            form: params.FORMAT_EXAM_NAME,
                            format: params.FORM_EXAM_CODE,
                            branch: params.CAMPUS_NAME,
                            canPassTestFrom: formatDate(params.ETP_FROM),
                            canPassTestTo: formatDate(params.ETP_TO),
                          }

                          let canPassTest = checkPeriod(false, dateObject.canPassTestTo);
                          examObject.datetimeSelectItems.push(dateObject)
                          if (Date.parse(datetime) >= Date.now() && canPassTest) {
                            examObject.datetimeSelectItems.push(dateObject)
                            examObject.filteredDatetimeSelectItems.push(dateObject)

                            if (isRemote && !haveRemoteSlots) {
                              haveRemoteSlots = true
                            }

                            if (params.CAMPUS_NAME) {
                              examObject.branchSelectItems.push(params.CAMPUS_NAME)
                            }
                          }
                        }

                        examObject.branchSelectItems = [...new Set(examObject.branchSelectItems)]
                        examObject.filteredBranchSelectItems = [...examObject.branchSelectItems]

                        // if (haveRemoteSlots && !examObject.formSelectItems.includes("Онлайн")) {
                        //   examObject.formSelectItems.push('Онлайн')
                        // }
                        if (params.FORMAT_EXAM_NAME && !examObject.formSelectItems.includes(params.FORMAT_EXAM_NAME)) {
                          examObject.formSelectItems.push(params.FORMAT_EXAM_NAME)
                        }
                        if (params.FORM_EXAM_NAME && !examObject.formatSelectItems.find((e) => e.name === params.FORM_EXAM_NAME)) {
                          examObject.formatSelectItems.push({
                            name: params.FORM_EXAM_NAME,
                            value: params.FORM_EXAM_CODE,
                            format: params.FORMAT_EXAM_NAME,
                          })
                        }

                        // if (examObject.branchSelectItems.length && !examObject.formSelectItems.includes("Очная")) {
                        //   examObject.formSelectItems.push('Очная')
                        // }
                      })
                    }

                    tests.push(examObject)
                  })
                }
                commit('SET_ALL_TESTS', tests);
              })
              .catch(error => {
                commit('SET_TESTS_ERROR', {message: error.message, block: 'registration'})
                commit("STOP_LOADER")
                setTimeout(() => {
                  commit('CLEAR_TESTS_ERROR', 'registration')
                }, 10000)
              })
        })
        .catch(error => {
          //commit('SET_TESTS_ERROR', {message: error.message, block: 'registration'})
          commit("STOP_LOADER")
          // setTimeout(() => {
          //   commit('CLEAR_TESTS_ERROR', 'registration')
          // }, 10000)
        })
  },
  async setSelectedTests({commit, state}) {
    this.$api("getEntranceTestRequest", {
      "filter": {},
      "select": [],
      "order": [],
      "limit": 0
    }, 'POST')
        .then(result => {
          let tests = []
          if (result.data.EntranceTestRequests && result.data.EntranceTestRequests.length) {
            result.data.EntranceTestRequests.forEach(test => {
              if (test.DATE_ACTIVE_FROM) {
                const datetime = formatDate(test.DATE_ACTIVE_FROM)
                const examDate = parseCustomDate(test.DATE_ACTIVE_FROM);
                const canStartExam = Date.now() >= new Date(examDate.setDate(examDate.getDate() - 1))
                    .setHours(0, 0, 0, 0);
                const testObject = {
                  title: test.PROPERTY_DISCIPLINE_NAME,
                  code: test.PROPERTY_DISCIPLINE_VALUE.toString(),
                  id: test.ID.toString(),
                  moodleId: test.MOODLE_ID ? test.MOODLE_ID.toString() : null,
                  form: test.PROPERTY_SCHEDULE_SLOT_PROPERTY_REMOTE_VALUE ? "Онлайн" : 'Очная',
                  branch: test.PROPERTY_SCHEDULE_SLOT_PROPERTY_REMOTE_VALUE ? "Онлайн" : test.PROPERTY_SCHEDULE_SLOT_PROPERTY_CAMPUS_NAME,
                  datetime: formatDate(test.DATE_ACTIVE_FROM),
                  datetimeId: test.PROPERTY_SCHEDULE_SLOT_VALUE,
                  canStartExam: canStartExam,
                  date: datetime.split('T')[0].split('-').reverse().join('.'),
                  time: datetime.split('T')[1].slice(0, 5),
                  status: test.PROPERTY_STATUS_VALUE === 'confirmed' ? 'Подтверждено' : "Не подтверждено",
                  token: test.TOKEN,
                  testUrl: test.TEST_URL,
                }
                tests.push(testObject)
              }
            })
          }

          if (tests.length > 1) {
            tests.sort((a, b) => {
              const datetimeA = Date.parse(a.datetime)
              const datetimeB = Date.parse(b.datetime)
              return datetimeA > datetimeB ? 1 : datetimeA < datetimeB ? -1 : 0
            })
          }

          commit('SET_SELECTED_TESTS', tests);
        })
        .catch(error => {
          if (error.message !== 'Не найдено элементов') {
            commit('SET_TESTS_ERROR', {message: error.message, block: 'tests'})
            setTimeout(() => {
              commit('CLEAR_TESTS_ERROR', 'tests')
            }, 10000)
          }
        })
  },
  async setTestsResults({commit, state}) {
    this.$api("getMyExamsResults", {}, 'POST')
        .then(result => {
          const disciplines = result.data.examsByDisciplines
          let results = []
          if (disciplines && Object.keys(disciplines).length) {
            for (let element in disciplines) {
              if (disciplines[element].length) {
                disciplines[element].forEach(discipline => {
                  const params = discipline.PROPERTIES
                  const exam = discipline.EXAM[0]
                  const examParams = exam?.PROPERTIES

                  let datetime

                  if (params.DATE) {
                    if (params.DATE.length === 10) {
                      datetime = `${params.DATE} 00:00`
                    } else {
                      datetime = params.DATE.slice(0, 16)
                    }
                  } else {
                    datetime = ''
                  }

                  const appealDateFrom = examParams.APPEAL_FROM === '01.01.0001'
                      ? null
                      : formatDate(examParams.APPEAL_FROM)
                  const appealDateTo = examParams.APPEAL_TO === '01.01.0001'
                      ? null
                      : formatDate(examParams.APPEAL_TO)
                  const testDocumentViewFrom = examParams.VIEW_WORK_FROM === '01.01.0001'
                      ? null
                      : formatDate(examParams.VIEW_WORK_FROM)
                  const testDocumentViewTo = examParams.VIEW_WORK_TO === '01.01.0001'
                      ? null
                      : formatDate(examParams.VIEW_WORK_TO)

                  const disciplineObject = {
                    id: discipline.ID.toString(),
                    examId: discipline.EXAM[0].ID,
                    title: params.DISCIPLINE_NAME,
                    nameTest: exam?.NAME ?? '',
                    code: params.DISCIPLINE,
                    form: params.PLACE ? 'Очная' : 'Онлайн',
                    branch: params.PLACE ? params.PLACE : 'Онлайн',
                    datetime: datetime,
                    score: +params.SCORE,
                    appealStatus: null,
                    appealResult: +params.APPEAL_SCORE,
                    appealReason: null,
                    appealDate: null,
                    appealDateFrom: appealDateFrom,
                    appealDateTo: appealDateTo,
                    canSendAppeal: true,
                    appealDocument: params.APPEAL_FILE,
                    testDocument: params.WORK_FILE,
                    testDocumentViewFrom: testDocumentViewFrom,
                    testDocumentViewTo: testDocumentViewTo,
                    canViewWork: true,
                    isRemovedFromExam: params.REMOVED_FROM_EXAM === 'Y',
                    commentExamStatus: params.COMMENT_STATUS_EXAM ?? '',
                    statusExam: params.STATUS_EXAM_NAME ?? ''
                  }

                  if (discipline.APPEAL) {
                    const appealParams = discipline.APPEAL.PROPERTIES
                    disciplineObject.appealStatus = appealParams.STATUS
                    disciplineObject.appealDocument = appealParams.APPEAL_RES_FILE
                    disciplineObject.appealReason = appealParams.REASON
                        ? appealParams.REASON
                        : 'Ваша апелляция была отклонена'
                    disciplineObject.appealDate = discipline.APPEAL.DATE_CREATE
                  }

                  disciplineObject.canViewWork = checkPeriod(disciplineObject.testDocumentViewFrom, disciplineObject.testDocumentViewTo)
                  disciplineObject.canSendAppeal = checkPeriod(disciplineObject.appealDateFrom, disciplineObject.appealDateTo)

                  results.push(disciplineObject)
                })
              }
            }
          }

          commit('SET_TESTS_RESULTS', results);
        })
        .catch(error => {
          commit('SET_TESTS_ERROR', {message: error.message, block: 'results'})
          setTimeout(() => {
            commit('CLEAR_TESTS_ERROR', 'results')
          }, 10000)
        })
  },
  async addTests({commit, state}) {
    const dataToSend = []
    const sameDateDisciplinesArray = []
    state.allTests.forEach(test => {
      if (test.save === true && test.datetime && !test.hidden) {
        const testObject = {
          SCHEDULE_SLOT: test.datetime.id,
          DISCIPLINE: test.code,
          ID: null,
        }
        if (test.id) {
          testObject.ID = test.id
        }
        if (test.sameDateWarningFile) {
          testObject.FILE = test.sameDateWarningFile.fileId
        }
        dataToSend.push(testObject)
      }
    })
    if (dataToSend.length) {
      this.$api("setEntrantTest", {ENTRANT_TEST: dataToSend}, "POST")
          .then(result => {
            commit('ADD_TESTS', result.data.ids);
          })
          .catch(error => {
            commit('SET_TESTS_ERROR', {message: error.message, block: 'registration'})
            setTimeout(() => {
              commit('CLEAR_TESTS_ERROR', 'registration')
            }, 10000)
          })
    }
  },
  changeTests({commit}, params) {
    commit('CHANGE_TESTS', params);
  },
  clearTestValues({commit}, testId) {
    commit('CLEAR_TEST', testId);
  },
  async editTest({commit}, test) {
    //commit('EDIT_TEST', test);
  },
  async deleteTest({commit}, test) {
    commit('DELETE_TEST', test);
  },
  uploadSameDateTestsStatement({commit}, fileData) {
    commit('UPLOAD_STATEMENT', fileData);
  },
  uploadAppeal({commit, state}, params) {
    commit('UPLOAD_APPEAL', params);
  },
  setTestsError({commit}, error) {
    commit('SET_TESTS_ERROR', error);
  },
  clearTestsError({commit}, block) {
    commit('CLEAR_TESTS_ERROR', block);
  }
}
export const mutations = {
  SET_DISCIPLINES(state, disciplines) {
    state.disciplines = [...disciplines];
  },
  SET_ALL_TESTS(state, allTests) {
    // если экзамен уже есть в списке выбранных - заполняем значения полей
    if (state.selectedTests.length && allTests.length) {
      state.selectedTests.forEach(selectedTest => {
        const test = allTests.find(item => {
          return item.code === selectedTest.code
        })
        if (test) {
          test.hidden = true
          const datetime = test.datetimeSelectItems.find(datetimeObj => {
            return datetimeObj.id === selectedTest.datetimeId
          })
          if (datetime) {
            test.form = selectedTest.form
            test.branch = selectedTest.branch
            test.datetime = datetime
            test.id = selectedTest.id
          }
        }
      })
    }
    // скрываем экзамен, если он уже есть в списке результатов
    if (state.testsResults.length && allTests.length) {
      state.testsResults.forEach(result => {
        const test = allTests.find(item => {
          return item.code === result.code
        })
        if (test) {
          test.hidden = true
        }
      })
    }

    if (allTests.length) {
      allTests.forEach(test => {
        // const sameDateTestsArray = allTests.filter(item => {
        //   if (item.datetime.datetime && test.datetime.datetime) {
        //     return item.datetime.datetime.slice(0, 10) === test.datetime.datetime.slice(0, 10)
        //   }
        // })

        if (test.datetime.datetime) {
          if (!state.selectedDatetimeArray.length) {
            state.selectedDatetimeArray.push({
              date: test.datetime.datetime.slice(0, 10),
              items: [{
                code: test.code,
                datetime: test.datetime.datetime
              }]
            })
          } else {
            const haveDateObject = state.selectedDatetimeArray.find(selectedItem => {
              return selectedItem.date === test.datetime.datetime.slice(0, 10)
            })
            if (haveDateObject) {
              const haveCodeObjectIndex = haveDateObject.items.findIndex(item => item.code === test.code)
              if (haveCodeObjectIndex !== -1) {
                haveDateObject.items[haveCodeObjectIndex].datetime = test.datetime.datetime
              } else {
                haveDateObject.items.push({
                  code: test.code,
                  datetime: test.datetime.datetime
                })
              }
            } else {
              state.selectedDatetimeArray.push({
                date: test.datetime.datetime.slice(0, 10),
                items: [{
                  code: test.code,
                  datetime: test.datetime.datetime
                }]
              })
            }
          }
        }
      })
    }

    state.testsPageLoading = false

    state.allTests = [...allTests]
  },
  SET_SELECTED_TESTS(state, selectedTests) {
    // заполняем значения полей в списке всех экзаменов, если результат по allTests пришел раньше
    if (state.allTests.length && selectedTests.length) {
      selectedTests.forEach(selectedTest => {
        const test = state.allTests.find(item => {
          return item.code === selectedTest.code
        })
        if (test) {
          test.hidden = true
          const datetime = test.datetimeSelectItems.find(datetimeObj => {
            return datetimeObj.id === selectedTest.datetimeId
          })
          if (datetime) {
            test.form = selectedTest.form
            test.branch = selectedTest.branch
            test.datetime = datetime
            test.id = selectedTest.id
          }
        }
      })
    }
    state.selectedTests = [...selectedTests]
  },
  SET_TESTS_RESULTS(state, results) {
    //скрываем экзамен, если он уже есть в списке результатов и allTests пришел раньше
    if (results.length && state.allTests.length) {
      results.forEach(result => {
        const test = state.allTests.find(item => {
          return item.code === result.code
        })
        if (test) {
          test.hidden = true
        }
      })
    }
    let formattedData = results

    function chooseWordForm(num, endings, cases = [2, 0, 1, 1, 1, 2]) {
      return endings[(num % 100 > 4 && num % 100 < 20) ? 2 : cases[(num % 10 < 5) ? num % 10 : 5]]
    }

    for (let item of formattedData) {
      let scoreDifference
      let finalScorePrefix

      if (item.appealResult) {
        scoreDifference = item.appealResult - item.score
        finalScorePrefix = scoreDifference > 0 ? '+' : scoreDifference < 0 ? '-' : ''
        if (scoreDifference < 0) scoreDifference = scoreDifference * -1
        item.appealResultLabel = `(${finalScorePrefix}${scoreDifference} ${chooseWordForm(scoreDifference, ['балл', 'баллa', 'баллов'])})`;
      } else {
        item.appealResultLabel = null
      }
      let appealActiveDays
      if (item.appealDateBy) {
        const currentDay = new Date().getTime()
        const appealDayBy = new Date(item.appealDateBy).getTime()
        appealActiveDays = Math.round((appealDayBy - currentDay) / (1000 * 60 * 60 * 24))
      }
      let itemDisplayScore = item.appealResult && Number(item.appealResult) > -1 ? item.appealResult : item.score;
      item.score = `${item.score} ${chooseWordForm(item.score, ['балл', 'баллa', 'баллов'])}`;
      item.displayScore = `${itemDisplayScore} ${chooseWordForm(itemDisplayScore, ['балл', 'баллa', 'баллов'])}`;
      item.appealActiveDays = appealActiveDays > 0 ?
          `${chooseWordForm(appealActiveDays, ['Остался', 'Осталось', 'Осталось'])} ${appealActiveDays} ${chooseWordForm(appealActiveDays, ['день', 'дня', 'дней'])}` :
          ''
    }
    state.testsResults = formattedData
  },
  ADD_TESTS(state, idsArray) {
    let testsToAdd = []
    let i = 0
    state.allTests.forEach(test => {
      if (test.form && test.datetime && !test.hidden) {
        const datetime = test.datetimeSelectItems.find(i => i.id === test.datetime.id).datetime
        if (datetime) {
          testsToAdd.push({
            title: test.title,
            id: idsArray[i],
            code: test.code,
            status: "Не подтверждено",
            form: test.form,
            branch: test.branch,
            datetime: datetime,
            date: datetime.split('T')[0].split('-').reverse().join('.'),
            time: datetime.split('T')[1].slice(0, 5),
            canStartExam: Date.now() >= Date.parse(`${datetime.slice(0, 10)}T00:01`)
          })
        }

        test.id = idsArray[i]
        test.hidden = true
        i++
      }
    })

    if (testsToAdd.length > 1) {
      testsToAdd.sort((a, b) => {
        const datetimeA = Date.parse(a.datetime)
        const datetimeB = Date.parse(b.datetime)
        return datetimeA > datetimeB ? 1 : datetimeA < datetimeB ? -1 : 0
      })
    }
    state.selectedTests.push(...testsToAdd)
  },
  CHANGE_TESTS(state, params) {
    const changedTestIndex = state.allTests.findIndex(item => item.code === params.code)
    const changedTest = state.allTests[changedTestIndex]
    changedTest[params.fieldName] = params.value


    const getFilterDate = (arrSource, key, val) => {
      return arrSource.filter(item => {
        let canPassTest = checkPeriod(false, item.canPassTestTo);
        const isFutureDate = Date.parse(item.datetime) >= Date.now()

        return item[key] === val && isFutureDate && canPassTest
      })
    }

    // если меняется форма проведения, сбрасывается время и кампус, фильтруется время и формат
    if (params.fieldName === 'form') {
      changedTest.save = false;
      changedTest.datetime = ''
      changedTest.branch = ''
      changedTest.format = ''
      changedTest.filteredDatetimeSelectItems = getFilterDate(changedTest.datetimeSelectItems, params.fieldName, params.value)
      changedTest.formatSelectItems = changedTest.formatSelectItems.filter((item) => {
        return item.format === params.value
      })
      // changedTest.filteredDatetimeSelectItems = changedTest.datetimeSelectItems.filter(item => {
      //   let canPassTest = checkPeriod(item.canPassTestFrom, item.canPassTestTo)
      //   const isFutureDate = Date.parse(item.datetime) >= Date.now()

      //   return item.form === params.value && isFutureDate && canPassTest

        // if (params.value === 'Очная') {
        //   return !item.remote && isFutureDate && canPassTest
        // } else if (params.value === 'Онлайн') {
        //   return item.remote && isFutureDate && canPassTest
        // } else {
        //   return isFutureDate && canPassTest
        // }
      // })
    }
    if (params.fieldName === 'format') {
      changedTest.save = false;
      changedTest.datetime = ''
      changedTest.branch = ''
      const tempArr = getFilterDate(changedTest.datetimeSelectItems, params.fieldName, params.value)
      changedTest.filteredDatetimeSelectItems = changedTest.form ? getFilterDate(tempArr, 'form', changedTest.form) : []
    }
    if (params.fieldName === 'branch') {
      changedTest.save = false;
      changedTest.filteredDatetimeSelectItems = changedTest.datetimeSelectItems.filter(date => {

        let canPassTest = checkPeriod(false, date.canPassTestTo)
        const isFutureDate = Date.parse(date.datetime) >= Date.now()
        return date.branch === params.value && isFutureDate && canPassTest
      })
    }
    if (params.fieldName === 'datetime') {
      changedTest.save = false;
      state.selectedDatetimeArray = []

      state.allTests.forEach(test => {
        const sameDateTestsArray = state.allTests.filter(item => {
          if (item.datetime.datetime && test.datetime.datetime) {
            return item.datetime.datetime.slice(0, 10) === test.datetime.datetime.slice(0, 10)
          }
        })

        if (test.datetime.datetime) {
          if (!state.selectedDatetimeArray.length) {
            state.selectedDatetimeArray.push({
              date: test.datetime.datetime.slice(0, 10),
              items: [{
                code: test.code,
                datetime: test.datetime.datetime
              }]
            })
          } else {
            const haveDateObject = state.selectedDatetimeArray.find(selectedItem => {
              return selectedItem.date === test.datetime.datetime.slice(0, 10)
            })
            if (haveDateObject) {
              const haveCodeObjectIndex = haveDateObject.items.findIndex(item => item.code === test.code)
              if (haveCodeObjectIndex !== -1) {
                haveDateObject.items[haveCodeObjectIndex].datetime = test.datetime.datetime
              } else {
                haveDateObject.items.push({
                  code: test.code,
                  datetime: test.datetime.datetime
                })
              }
            } else {
              state.selectedDatetimeArray.push({
                date: test.datetime.datetime.slice(0, 10),
                items: [{
                  code: test.code,
                  datetime: test.datetime.datetime
                }]
              })
            }
          }
        }
      })
    }
  },
  CLEAR_TEST(state, testId) {
    const clearedTest = state.allTests.find(test => test.code === testId)
    if (clearedTest) {
      if (state.selectedDatetimeArray.length) {
        const clearedDateObject = state.selectedDatetimeArray.find(item => item.date === clearedTest.datetime?.datetime?.slice(0, 10))
        if (clearedDateObject && clearedDateObject.items.length) {
          clearedDateObject.items = clearedDateObject.items.filter(item => {
            return item.code !== clearedTest.code
          })
          if (!clearedDateObject.items.length) {
            state.selectedDatetimeArray = state.selectedDatetimeArray.filter(dateObj => dateObj.date !== clearedDateObject.date)
          }
        }
      }
      clearedTest.branch = ''
      clearedTest.datetime = ''
      clearedTest.form = ''
      clearedTest.format = ''
      clearedTest.sameDateWarningFile = null
    }
  },
  // EDIT_TEST(state, test) {
  //   const editedSelectedTestsIndex = state.selectedTests.findIndex(item => item.code === test.code)
  //   const editedAllTestsIndex = state.allTests.findIndex(item => item.code === test.code)
  //   if (editedAllTestsIndex !== -1) {
  // state.allTests[editedAllTestsIndex].datetime =
  //     state.allTests[editedAllTestsIndex].datetimeSelectItems.find(item => {
  //       return item.label === state.selectedTests[editedSelectedTestsIndex].datetime
  //     })
  // state.allTests[editedAllTestsIndex].form = state.selectedTests[editedSelectedTestsIndex].form
  //
  // state.allTests[editedAllTestsIndex].branch =
  //     state.allTests[editedAllTestsIndex].branchSelectItems.find(item => {
  //       return item.label === state.selectedTests[editedSelectedTestsIndex].branch
  //     })
  //     state.allTests[editedAllTestsIndex].hidden = false
  //   }
  //   state.selectedTests.splice(editedSelectedTestsIndex, 1)
  // },
  DELETE_TEST(state, test) {
    state.selectedTests = state.selectedTests.filter(item => item.code !== test.code);

    if (state.selectedDatetimeArray.length) {
      state.selectedDatetimeArray.forEach(selectedDateObject => {
        if (selectedDateObject.date === test.datetime.slice(0, 10)) {
          selectedDateObject.items = selectedDateObject.items.filter(item => {
            return item.code !== test.code
          })
        }
      })
    }

    const deletedTest = state.allTests.find(item => item.code === test.code)
    if (deletedTest) {
      deletedTest.hidden = false
      deletedTest.id = null
      deletedTest.form = ''
      deletedTest.branch = ''
      deletedTest.datetime = ''
      deletedTest.sameDateWarningFile = null
    }
  },
  UPLOAD_STATEMENT(state, fileData) {
    const testWithFile = state.allTests.find(test => test.code === fileData.code)
    let sameDateTests = []
    const selectedDateArray = state.selectedDatetimeArray.forEach(dateObject => {
      if (dateObject.date === fileData.date) {
        dateObject.items.forEach(item => {
          if (item.code !== fileData.code) {
            sameDateTests.push(item.code)
          }
        })
      }
    })

    if (sameDateTests.length) {
      state.allTests.forEach(test => {
        if (sameDateTests.includes(test.code) && test.code !== fileData.code) {
          test.sameDateWarningFile = null
        }
      })
    }

    if (testWithFile) {
      if (testWithFile.sameDateWarningFile) {
        testWithFile.file = fileData.file
        testWithFile.fileId = fileData.fileId
        testWithFile.date = fileData.date
      } else {
        testWithFile.sameDateWarningFile = {
          code: fileData.code,
          file: fileData.file,
          formData: fileData.formData,
          fileId: fileData.fileId,
          date: fileData.date,
        }
      }
    }
  },
  UPLOAD_APPEAL(state, params) {
    const testForAppealIndex = state.testsResults.findIndex(item => item.id === params.resultId)
    if (testForAppealIndex !== -1) {
      state.testsResults[testForAppealIndex].appealStatus = 'new'
      state.testsResults[testForAppealIndex].appealDate = new Date().replace(',', '')
    }
  },
  SET_TESTS_ERROR(state, error) {
    state.testsError[error.block] = error.message;
  },
  CLEAR_TESTS_ERROR(state, block) {
    state.testsError[block] = ""
  },
  STOP_LOADER(state) {
    state.testsPageLoading = false
  }
}


export const getters = {
  getAllTests(state) {
    return state.allTests
  },
  getDisciplinesLength(state) {
    return state.disciplines.length
  },
  getAllTestsLength(state) {
    return state.allTests.length
  },
  getSavedTests(state) {
    return state.allTests.filter(test => !test.hidden && test.save === true);
  },
  getCreativeTests(state) {
    let creativeTests = []
    state.allTests.forEach(test => {
      if (test.type.toLowerCase().includes('творческ')) {
        creativeTests.push(test)
      }
    })
    return creativeTests
  },
  getSelectedTests(state) {
    return state.selectedTests;
  },
  getTestsResults(state) {
    return state.testsResults
  },
  getTestsErrors(state) {
    return state.testsError;
  },
  getSameDateStatementFiles(state) {
    let files = []
    state.allTests.forEach(test => {
      if (test.sameDateWarningFile) {
        files.push(test.sameDateWarningFile)
      }
    })
    return files;
  },
  getSelectedDatetimeArray(state) {
    return state.selectedDatetimeArray;
  },
  getTestsPageLoading(state) {
    return state.testsPageLoading;
  },
};
